export const faqList = [
  {
    question: "玫瑰视频是否需要注册才能观看？",
    answer: "不需要！玫瑰视频所有内容完全免费，无需注册即可在线观看。我们致力于为影迷提供最便捷的观影体验，打开网站就能直接观看您喜欢的内容。"
  },
  {
    question: "为什么玫瑰视频播放不会缓冲卡顿？",
    answer: "玫瑰视频采用了先进的CDN加速技术和智能码率适配系统。我们的服务器分布在全国主要城市，系统会根据您的网络状况自动调整最佳清晰度，确保您获得流畅的观影体验。"
  },
  {
    question: "玫瑰视频的资源更新速度如何？",
    answer: "玫瑰视频与红桃视频、樱桃视频、茄子视频、糖心视频等主流平台保持同步更新。最新电视剧和电影上线后，我们会在24小时内完成资源同步，让您第一时间看到最新内容。"
  },
  {
    question: "玫瑰视频支持哪些设备观看？",
    answer: "玫瑰视频全面兼容电脑、平板和手机等多种设备。无论您使用Windows、Mac、iOS还是Android系统，都可以通过浏览器直接访问观看，无需下载任何软件。"
  },
  {
    question: "玫瑰视频的画质如何？",
    answer: "我们提供从标清到超清多种画质选择，最高支持1080P全高清画质。部分热门内容还支持4K超高清播放，让您享受影院级的观影体验。"
  },
  {
    question: "如何在玫瑰视频上找到想看的影片？",
    answer: "您可以通过首页的分类导航浏览不同类型的影片，也可以使用搜索功能直接输入影片名称。我们还提供了热门标签和推荐列表，帮助您发现更多精彩内容。"
  }
];

export const aboutInfo = {
  brand: {
    title: "关于玫瑰视频",
    intro: "玫瑰视频成立于2024年，是国内领先的高清视频资源聚合平台。我们汇聚了红桃视频、樱桃视频、茄子视频、糖心视频等主流平台的优质内容，为千万用户提供免费、高清、流畅的在线观影体验。",
    mission: "让每一个人都能轻松享受高质量的影视内容，是玫瑰视频始终不变的使命。",
    vision: "成为华语地区最受欢迎的视频资源聚合平台，用技术驱动观影体验的持续升级。",
    values: ["用户至上", "品质第一", "技术创新", "开放共享"]
  },
  stats: [
    { label: "日均活跃用户", value: "500万+" },
    { label: "影视资源库", value: "10万+" },
    { label: "合作平台", value: "50+" },
    { label: "用户好评率", value: "98.6%" }
  ],
  testimonials: [
    {
      name: "王先生",
      location: "北京",
      content: "玫瑰视频真的太方便了！以前要在好几个App之间切换追剧，现在一个网站全搞定，画质清晰还不卡顿，强烈推荐！",
      rating: 5
    },
    {
      name: "李女士",
      location: "上海",
      content: "作为一个追剧狂人，玫瑰视频简直就是我的救星。资源更新快，分类清晰，界面也很清爽，用了就回不去了。",
      rating: 5
    },
    {
      name: "张同学",
      location: "广州",
      content: "放学回家就打开玫瑰视频看纪录片，内容丰富质量高。最赞的是不用注册就能看，太良心了！",
      rating: 5
    },
    {
      name: "陈女士",
      location: "成都",
      content: "朋友推荐的玫瑰视频，一开始还不太相信有这么好的免费网站。用了半年了，真的是宝藏平台，片源全画质好。",
      rating: 5
    }
  ],
  contact: {
    email: "service@meiguivideo.com",
    wechat: "玫瑰视频官方",
    weibo: "@玫瑰视频官方",
    hours: "周一至周日 9:00-21:00",
    address: "北京市朝阳区科技园区玫瑰大厦"
  }
};